// A one-time hand-off code (TW-1087): 48 hex characters minted by the API's
// createHandoffCode for the caller's token, exchanged for that token exactly once
// within a minute. It stands in for the token wherever a URL has to carry one (the
// CMS link, the PDF export, the CMS-to-site SSO fragment). Kept free of imports so
// parseToken.ts can use it while the auth slice is still being evaluated.
export const HANDOFF_CODE_PATTERN = /^[0-9a-f]{48}$/;
